import React from 'react';
import PropertyAlertsCTA from '../../../components/property-alerts-cta/PropertyAlertsCTA';
import AutoApplyCTA from '../../../components/auto-apply-cta/AutoApplyCTA';
import { SupportNetwork } from '../../../components/support-network/SupportNetwork';
import PropertyCategoriesCarousel from '../../../components/property-categories-carousel/PropertyCategoriesCarousel';
import SocialProof from '../../../components/social-proof/SocialProof';
import PropertyListingCTA from '../../../components/property-listing-cta/PropertyListingCTA';
import FeedbackCard from '../../../components/feedback-card/FeedbackCard';
import FeedbackForm from '../../../components/feedback-form/FeedbackForm';
import HowItWorksAccordion from '../../../components/how-it-works-accordion/HowItWorksAccordion';
import { remoteConfig } from '../../../utility/firebaseRemoteConfigHelper';
import DiscoverAreasUpsell from '../../../components/discover-areas/DiscoverAreasUpsell';
import DiscoverPriceTrendsUpsell from '../../../components/discover-areas/DiscoverPriceTrendsUpsell';

const CTASection: React.FC = () => {
  return (
    <>
      <PropertyAlertsCTA />
      <HowItWorksAccordion />
      {remoteConfig.isAutoApplyEnabled() && <AutoApplyCTA className="mb-8" />}
      <SupportNetwork />
      <DiscoverAreasUpsell />
      <DiscoverPriceTrendsUpsell />
      {/* <RandomInsight /> */}
      <PropertyCategoriesCarousel />
      <SocialProof userType="renter" />
      <PropertyListingCTA />

      {remoteConfig.isFeedbackEnabled() && (
        <>
          <FeedbackCard
            variant="compact"
            title="Quick Feedback"
            subtitle="Tell us what you think"
          />
          <FeedbackForm />
        </>
      )}
    </>
  );
};

export default CTASection;
